import { __decorate, __metadata, __rest } from "tslib";
import { Injectable } from '@angular/core';
import { GridStateStore } from './grid-state.store';
import { TabIdService } from './tab-id.service';
let GridStateService = class GridStateService {
    constructor(store, tabIdService) {
        this.store = store;
        this.tabIdService = tabIdService;
        this.gridIdsToClear = [];
    }
    initTab() {
        let tabId = this.tabIdService.getOrCreateTabId();
        this.tabId = tabId;
        const currentState = this.store.getValue();
        if (!currentState.tabs[tabId]) {
            this.store.update({
                tabs: Object.assign(Object.assign({}, currentState.tabs), { [tabId]: {} }),
            });
        }
        this.clearEmptyTabs();
    }
    setGridState(gridId, state) {
        const currentState = this.store.getValue();
        const tabState = currentState.tabs[this.tabId] || {};
        this.store.update({
            tabs: Object.assign(Object.assign({}, currentState.tabs), { [this.tabId]: Object.assign(Object.assign({}, tabState), { [gridId]: state }) }),
        });
        this.removeFromClearList(gridId);
    }
    addToClearList(gridId) {
        if (!this.gridIdsToClear.includes(gridId)) {
            this.gridIdsToClear.push(gridId);
        }
    }
    removeFromClearList(gridId) {
        this.gridIdsToClear = this.gridIdsToClear.filter((id) => id !== gridId);
    }
    clearGridState(gridId) {
        this.store.update((state) => {
            const tabState = state.tabs[this.tabId] || {};
            const _a = tabState, _b = gridId, _ = _a[_b], restTabs = __rest(_a, [typeof _b === "symbol" ? _b : _b + ""]);
            return {
                tabs: Object.assign(Object.assign({}, state.tabs), { [this.tabId]: restTabs }),
            };
        });
    }
    clearGridIds() {
        this.gridIdsToClear.forEach((gridId) => this.clearGridState(gridId));
        this.gridIdsToClear = [];
    }
    clearEmptyTabs() {
        const currentState = this.store.getValue();
        const newTabs = {};
        for (const tab of Object.keys(currentState.tabs)) {
            const tabData = currentState.tabs[tab];
            if (tab === this.tabId || Object.keys(tabData).length) {
                newTabs[tab] = tabData;
            }
        }
        this.store.update(Object.assign(Object.assign({}, currentState), { tabs: newTabs }));
    }
    clearAll() {
        this.store.reset();
    }
};
GridStateService.ctorParameters = () => [
    { type: GridStateStore },
    { type: TabIdService }
];
GridStateService = __decorate([
    Injectable(),
    __metadata("design:paramtypes", [GridStateStore, TabIdService])
], GridStateService);
export { GridStateService };
